import { Modal } from "antd";
import * as React from "react";
import styled from "styled-components";

import { Icon } from "./Icon";
import { IconTypes } from "./index";
import { theme } from "./theme";

interface Props {
  isFullScreen: boolean;
  visible: boolean;
  onClose: () => void;
  children: MenuItemType[];
  className?: string;
  mobileHeader?: string;
}

interface MenuItemType {
  iconType?: React.ReactNode;
  text: string;
  onClick?: () => void;
}

export class Menu extends React.Component<Props> {
  render() {
    if (this.props.isFullScreen) {
      return this.renderMobileMenu();
    }
    return this.renderDesktopMenu();
  }

  private renderMobileMenu = () => {
    return (
      <Modal
        visible={this.props.visible}
        footer={null}
        closable={true}
        width="100%"
        style={{
          minHeight: "100vh",
          top: 0,
          padding: 0,
          margin: 0,
          borderRadius: 0,
        }}
        bodyStyle={{ minHeight: "100vh", padding: 0 }}
        onCancel={this.props.onClose}
      >
        <MobileHeader>{this.props.mobileHeader}</MobileHeader>
        {this.props.children.map(({ text, iconType, onClick }) => (
          <MobileMenuItem key={text} onClick={onClick}>
            <div>
              <Icon type={iconType as IconTypes} color={theme.textDeepGray} />
              {text}
            </div>
            <Icon type="arrow-right" color={theme.textDeepGray} />
          </MobileMenuItem>
        ))}
      </Modal>
    );
  };

  private renderDesktopMenu = () => {
    return (
      <DesktopMenuContainer className={this.props.className}>
        {this.props.children.map(({ text, iconType, onClick }) => (
          <DesktopMenuItem key={text} onClick={onClick}>
            <Icon type={iconType as IconTypes} color={theme.textDeepGray} />
            {text}
          </DesktopMenuItem>
        ))}
      </DesktopMenuContainer>
    );
  };
}

export const DesktopMenuContainer = styled.div`
  && {
    right: unset;
  }
  position: absolute;
  z-index: 1;
  width: 204px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  background-color: ${theme.white};
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  color: ${theme.textDeepGray};
  font-weight: 400;
  &:hover {
    cursor: pointer;
    color: ${theme.textDeepGray};
    background-color: #eff1f2;
  }
  ${Icon} {
    &:first-child {
      margin-right: 8px;
    }
  }
`;
export const MobileMenuItem = styled(MenuItem)`
  justify-content: space-between;
  font-size: ${theme?.fontSize?.body};
  margin: 0 16px;
  padding: 8px 0;
  &:hover {
    background-color: ${theme.white};
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${theme.bgGray};
  }
`;

const DesktopMenuItem = styled(MenuItem)`
  &:first-child::before {
    content: "▲";
    font-size: ${theme?.fontSize?.caption};
    position: absolute;
    left: 42px;
    top: -14px;
    color: ${theme.white};
    text-shadow: 0 -1px 2px rgba(176, 176, 176, 0.3);
  }
  &:first-child:hover::before {
    color: #eff1f2;
  }
`;

export const MobileHeader = styled.div`
  text-align: center;
  font-size: ${theme?.fontSize?.title3};
  padding: 32px 0 16px 0;
  color: ${theme.textColor};
  font-weight: 400;
`;
